import { Temporal } from 'temporal-polyfill';

const formatPlainDate = (date: string): string =>
  Temporal.PlainDate.from(date).toLocaleString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

export const parseReportDateToLocaleFormat = (date: string) =>
  formatPlainDate(date);

export const dateRangeToString = (dateRange: [string, string]): string =>
  dateRange.map(date => formatPlainDate(date)).join(' - ');

export const parseDateTimeToLocaleFormat = (dateTime: string): string =>
  Temporal.Instant.from(dateTime)
    .toZonedDateTimeISO(Temporal.Now.timeZoneId())
    .toLocaleString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

export const plainDateToEpochMs = (dateString: string): number =>
  Temporal.PlainDate.from(dateString).toZonedDateTime('UTC').epochMilliseconds;

export const epochMsToLocaleFormat = (epochMs: number): string =>
  Temporal.Instant.fromEpochMilliseconds(epochMs)
    .toZonedDateTimeISO('UTC')
    .toPlainDate()
    .toLocaleString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
